import { defineStore } from 'pinia'
import { ROUTE_MENU_MAP } from '@/config/menu'

export interface AppTab {
  key: string
  title: string
  path: string
}

export const useTabsStore = defineStore('tabs', {
  state: () => ({
    openTabs: [{ key: 'access-points', title: 'access-points', path: '/access-points' }] as AppTab[],
    activeKey: 'access-points',
  }),
  actions: {
    openTab(key: string, title: string, path: string) {
      const existing = this.openTabs.find(tab => tab.key === key)
      if (existing) {
        existing.title = title
        existing.path = path
      } else {
        this.openTabs.push({ key, title, path })
      }
      this.activeKey = key
    },
    switchTab(key: string) {
      if (this.openTabs.some(tab => tab.key === key)) {
        this.activeKey = key
      }
    },
    closeTab(key: string) {
      if (this.openTabs.length <= 1) return false
      const index = this.openTabs.findIndex(tab => tab.key === key)
      if (index < 0) return false
      this.openTabs.splice(index, 1)
      if (this.activeKey === key) {
        const next = this.openTabs[Math.max(0, index - 1)]
        this.activeKey = next.key
      }
      return true
    },
    syncTitle(key: string, title: string) {
      const tab = this.openTabs.find(item => item.key === key)
      if (tab) tab.title = title
    },
    initFromRoute(routeName?: string | null) {
      if (!routeName) return
      const menu = ROUTE_MENU_MAP[routeName]
      if (!menu) return
      this.openTab(routeName, routeName, menu.path)
    },
  },
})
